import { useState } from 'react'
import useProcurementTypeContext from './useProcurementTypeContext'
import useFormDataGetPageDataByRequest from '../../../@hooks/useFormDataGetPageDataByRequest'

export default function useGetProcurementList() {
  const { requestBaseModule } = useProcurementTypeContext()
  const [totalData, setTotalData] = useState({
    asPayTotalMoney: 0,
    asQuitTotalMoney: 0,
    noPayTotalMoney: 0,
    noQuitTotalMoney: 0,
    totalMoney: 0
  })
  const { pageData, getList, loading } = useFormDataGetPageDataByRequest(
    requestBaseModule.getList
  )

  const getAmountData = async params => {
    let data = await requestBaseModule.getCountMoney(params)
    data && setTotalData(data)
  }
  return {
    getListBasice: getList,
    pageData,
    loading,
    totalData,
    getAmountData
  }
}
